export default __webpack_public_path__ + "static/media/UMN-Framework for Planning-04.6e9e454d.jpg";